(function ($) {

  let formId = 'js-validation';
  // let formId = '';
  let custom_choice = ['radio', 'checkbox'];


  if (document.getElementById(formId) != null) {

    $(document).ready(function () {
      var formTag = $('#' + formId);

      $.extend($.validator.messages, {
        required: '必須項目です。',
        email: 'メールアドレスの形式が正しくありません。',
        zipcode: '郵便番号の形式が正しくありません。',
        alphanum: '半角英数字で入力してください。',
        alpha: '半角英字で入力してください。',
        phone: '半角数字と「-」のみ使用できます。',
        equalTo: '同じ値を入力してください。',
        number: '半角数字で入力してください。',
        notnumberonly: '半角数字のみの入力はできません。',
        digits: '半角数字で入力してください。',
        url: 'URLの形式が正しくありません。',
        date: '日付の形式が正しくありません。',
        minlength: $.validator.format("最低 {0} 文字以上で入力してください。"),
        maxlength: $.validator.format("最大 {0} 文字以下で入力してください。"),
        min: $.validator.format("{0} より大きな数にしてください。"),
        max: $.validator.format("{0} より小さな数にしてください。"),
        step: '{0} の倍数を入力してください。',
        kana: '全角ひらがな、カタカナで入力してください。',
        hiragana: '全角ひらがなで入力してください。',
        katakana: '全角カタカナで入力してください。',
        password: '半角英数字と記号「 - _ @ . 」のみで入力してください。',
        whichone: 'どちらか片方を設定してください。',
        differentall: '同じ値は入力できません。',
        accept: '許可されたファイル形式ではありません。',
        maxsize: 'ファイルサイズが大きすぎます。',
      });

      var methods = {
        zipcode: function (value, element) {
          return this.optional(element) || /^[0-9]{3}-?[0-9]{4}$/.test(value);
        },
        alphanum: function (value, element) {
          return this.optional(element) || /^[a-zA-Z0-9_]+$/.test(value);
        },
        alpha: function (value, element) {
          return this.optional(element) || /^[a-zA-Z]+$/.test(value);
        },
        phone: function (value, element) {
          return this.optional(element) || /^[0-9\-\ ]+$/.test(value);
        },
        kana: function (value, element) {
          return this.optional(element) || /^[ぁ-んァ-ヶー　\ ]+$/.test(value);
        },
        hiragana: function (value, element) {
          return this.optional(element) || /^[ぁ-んー　\ ]+$/.test(value);
        },
        katakana: function (value, element) {
          return this.optional(element) || /^[ァ-ヶー　\ ]+$/.test(value);
        },
        password: function (value, element) {
          return this.optional(element) || /^[a-zA-Z0-9_\-@\.]+$/.test(value);
        },
        notnumberonly: function (value, element) {
          reg = new RegExp("[^0-9]");
          return this.optional(element) || reg.test(value);
        },
        whichone: function (value, element, param) {
          var bool = true;
          if (value) {
            bool = ($(param).val()) ? false : true;
          }
          return bool;
        },
        differentall: function (value, element, param) {
          var bool = true;
          if (value) {
            $.each(param, function (index, name) {
              if ($('[name="' + name + '"]').val() == value) {
                bool = false;
              }
            })
          }
          return bool;
        },
        accept: function (value, element, param) {
          var typeParam = typeof param === "string" ? param.replace(/\s/g, "") : "image/*",
            optionalValue = this.optional(element),
            i, file, regex;

          if (optionalValue) {
            return optionalValue;
          }

          if ($(element).attr("type") === "file") {
            typeParam = typeParam
              .replace(/[\-\[\]\/\{\}\(\)\+\?\.\\\^\$\|]/g, "\\$&")
              .replace(/,/g, "|")
              .replace(/\/\*/g, "/.*");

            if (element.files && element.files.length) {
              regex = new RegExp(".?(" + typeParam + ")$", "i");
              for (i = 0; i < element.files.length; i++) {
                file = element.files[i];

                if (!file.type.match(regex)) {
                  return false;
                }
              }
            }
          }

          return true;
        },
        maxsize: function (value, element, param) {
          if (this.optional(element)) {
            return true;
          }

          if ($(element).attr("type") === "file") {
            if (element.files && element.files.length) {
              for (var i = 0; i < element.files.length; i++) {
                if (element.files[i].size > param) {
                  return false;
                }
              }
            }
          }

          return true;
        },
      };
      $.each(methods, function (key) {
        $.validator.addMethod(key, this);
      });


      if (document.URL.match('/wp/wp-admin/')) {
        $rules = {
          'form_post': {
            required: true,
            date: true,
          },
          'form_category[]': {
            required: true,
          },
          'form_display[]': {
            required: true,
          },
          'form_title': {
            required: true,
            maxlength: 180,
          },
          'form_link': {
            url: true,
          },

          'form_outline': {
            required: true,
          },
          'form_venue': {
            required: true,
          },
          'form_time_from': {
            required: true,
          },
          'form_time_until': {
            required: true,
          },
          'form_date': {
            required: true,
            // required: {
            //   depends: function (element) {
            //     return $('[name="form_date_note"]').val() == '';
            //   }
            // }
          },
          'form_request_1_id': {
            number: true,
          },
          'form_request_2_id': {
            number: true,
          },
          'form_request_3_id': {
            number: true,
          },
          'form_request_4_id': {
            number: true,
          },
          'form_request_5_id': {
            number: true,
          },
          'form_request_6_id': {
            number: true,
          },
          'form_request_7_id': {
            number: true,
          },
          'form_request_8_id': {
            number: true,
          },
          'form_request_9_id': {
            number: true,
          },
          'form_request_10_id': {
            number: true,
          },



          'form_event': {
            required: true,
          },
          'form_control': {
            required: true,
          },

          'form_display_type': {
            required: true,
          },
          'form_display_organization': {
            required: true,
          },
          'form_capacity': {
            required: {
              depends: function (element) {
                return $('[name="form_capacity_option"]').prop("checked");
              }
            }
          },
          'form_thanks': {
            required: true,
          },
          'form_custom_1_type': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_1"]').prop("checked");
              }
            }
          },
          'form_custom_1_name': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_1"]').prop("checked");
              }
            }
          },
          'form_custom_1_choice': {
            required: {
              depends: function (element) {
                return ($.inArray($('[name="form_custom_1_type"]').val(), custom_choice) !== -1);
              }
            }
          },
          'form_custom_2_type': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_2"]').prop("checked");
              }
            }
          },
          'form_custom_2_name': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_2"]').prop("checked");
              }
            }
          },
          'form_custom_2_choice': {
            required: {
              depends: function (element) {
                return ($.inArray($('[name="form_custom_2_type"]').val(), custom_choice) !== -1);
              }
            }
          },
          'form_custom_3_type': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_3"]').prop("checked");
              }
            }
          },
          'form_custom_3_name': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_3"]').prop("checked");
              }
            }
          },
          'form_custom_3_choice': {
            required: {
              depends: function (element) {
                return ($.inArray($('[name="form_custom_3_type"]').val(), custom_choice) !== -1);
              }
            }
          },
          'form_custom_4_type': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_4"]').prop("checked");
              }
            }
          },
          'form_custom_4_name': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_4"]').prop("checked");
              }
            }
          },
          'form_custom_4_choice': {
            required: {
              depends: function (element) {
                return ($.inArray($('[name="form_custom_4_type"]').val(), custom_choice) !== -1);
              }
            }
          },
          'form_custom_5_type': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_5"]').prop("checked");
              }
            }
          },
          'form_custom_5_name': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_5"]').prop("checked");
              }
            }
          },
          'form_custom_5_choice': {
            required: {
              depends: function (element) {
                return ($.inArray($('[name="form_custom_5_type"]').val(), custom_choice) !== -1);
              }
            }
          },
          'form_custom_6_type': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_6"]').prop("checked");
              }
            }
          },
          'form_custom_6_name': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_6"]').prop("checked");
              }
            }
          },
          'form_custom_6_choice': {
            required: {
              depends: function (element) {
                return ($.inArray($('[name="form_custom_6_type"]').val(), custom_choice) !== -1);
              }
            }
          },
          'form_custom_7_type': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_7"]').prop("checked");
              }
            }
          },
          'form_custom_7_name': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_7"]').prop("checked");
              }
            }
          },
          'form_custom_7_choice': {
            required: {
              depends: function (element) {
                return ($.inArray($('[name="form_custom_7_type"]').val(), custom_choice) !== -1);
              }
            }
          },
          'form_custom_8_type': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_8"]').prop("checked");
              }
            }
          },
          'form_custom_8_name': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_8"]').prop("checked");
              }
            }
          },
          'form_custom_8_choice': {
            required: {
              depends: function (element) {
                return ($.inArray($('[name="form_custom_8_type"]').val(), custom_choice) !== -1);
              }
            }
          },
          'form_custom_9_type': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_9"]').prop("checked");
              }
            }
          },
          'form_custom_9_name': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_9"]').prop("checked");
              }
            }
          },
          'form_custom_9_choice': {
            required: {
              depends: function (element) {
                return ($.inArray($('[name="form_custom_9_type"]').val(), custom_choice) !== -1);
              }
            }
          },
          'form_custom_10_type': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_10"]').prop("checked");
              }
            }
          },
          'form_custom_10_name': {
            required: {
              depends: function (element) {
                return $('[name="form_custom_10"]').prop("checked");
              }
            }
          },
          'form_custom_10_choice': {
            required: {
              depends: function (element) {
                return ($.inArray($('[name="form_custom_10_type"]').val(), custom_choice) !== -1);
              }
            }
          },
          'form_reply_subject': {
            required: {
              depends: function (element) {
                return $('[name="form_reply_option"]').prop("checked");
              }
            }
          },
          'form_reply_from_name': {
            required: {
              depends: function (element) {
                return $('[name="form_reply_option"]').prop("checked");
              }
            }
          },
          'form_reply_from': {
            required: {
              depends: function (element) {
                return $('[name="form_reply_option"]').prop("checked");
              }
            }
          },
          'form_reply_message': {
            required: {
              depends: function (element) {
                return $('[name="form_reply_option"]').prop("checked");
              }
            }
          },

          'form_attachment': {
            required: true,
            maxsize: 10485760,
            accept: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          },

          'form_member_ids': {
            required: true,
          },
          'form_batch': {
            required: true,
          },

          'form_user_login': {
            minlength: 8,
            required: true,
            number: true,
          },
          'form_user_pass': {
            minlength: 6,
            password: true,
            notnumberonly: true,
            required: {
              depends: function (element) {
                return (
                  $('[name="mode"]').length && $('[name="mode"]').val() !== 'edit'
                );
              }
            },
          },
          'form_password_old': {
            required: true,
            number: true,
          },
          'form_organization': {
            required: true,
          },
          'form_company': {
            required: true,
          },
          'form_company_kana': {
            required: true,
            kana: true,
          },
          'form_branch_kana': {
            kana: true,
          },
          'form_url': {
            url: true,
          },
          'form_name': {
            required: true,
          },
          'form_staff': {
            required: true,
          },
          'form_zipcode': {
            required: true,
            zipcode: true,
          },
          'form_address_1': {
            required: true,
          },
          'form_license': {
            required: true,
          },
          'form_tel': {
            required: true,
            phone: true,
          },
          'form_fax': {
            phone: true,
          },
          'form_email': {
            email: true,
            differentall: ['form_email_sub_1', 'form_email_sub_2', 'form_email_sub_3', 'form_email_sub_4', 'form_email_sub_5'],
            required: {
              depends: function (element) {
                return (
                  ($('[name="form_email_sub_1"]').length && $('[name="form_email_sub_1"]').val() !== '') ||
                  ($('[name="form_email_sub_2"]').length && $('[name="form_email_sub_2"]').val() !== '') ||
                  ($('[name="form_email_sub_3"]').length && $('[name="form_email_sub_3"]').val() !== '') ||
                  ($('[name="form_email_sub_4"]').length && $('[name="form_email_sub_4"]').val() !== '') ||
                  ($('[name="form_email_sub_5"]').length && $('[name="form_email_sub_5"]').val() !== '')
                );
              }
            }
          },
          'form_email_sub_1': {
            email: true,
            differentall: ['form_email', 'form_email_sub_2', 'form_email_sub_3', 'form_email_sub_4', 'form_email_sub_5'],
          },
          'form_email_sub_2': {
            email: true,
            differentall: ['form_email', 'form_email_sub_1', 'form_email_sub_3', 'form_email_sub_4', 'form_email_sub_5'],
          },
          'form_email_sub_3': {
            email: true,
            differentall: ['form_email', 'form_email_sub_1', 'form_email_sub_2', 'form_email_sub_4', 'form_email_sub_5'],
          },
          'form_email_sub_4': {
            email: true,
            differentall: ['form_email', 'form_email_sub_1', 'form_email_sub_2', 'form_email_sub_3', 'form_email_sub_5'],
          },
          'form_email_sub_5': {
            email: true,
            differentall: ['form_email', 'form_email_sub_1', 'form_email_sub_2', 'form_email_sub_3', 'form_email_sub_4'],
          },

          'form_auth_news': {
            required: true,
          },
          'form_auth_event': {
            required: true,
          },
          'form_auth_form': {
            required: true,
          },
          'form_auth_fax': {
            required: true,
          },
          'form_auth_members': {
            required: true,
          },
          'form_auth_managers': {
            required: true,
          },

          'form_password_new': {
            required: true,
            minlength: 6,
            password: true,
            notnumberonly: true,
          },
          'form_password_confirm': {
            required: true,
            equalTo: '#js-password',
          },


          // 'user_confirm': {
          //   required: {
          //     depends: function (element) {
          //       return document.URL.match('catalog/registration');
          //     }
          //   },
          // },

        };
      } else {
        $rules = {
          'form_email': {
            email: true,
            differentall: ['form_email_sub_1', 'form_email_sub_2', 'form_email_sub_3', 'form_email_sub_4', 'form_email_sub_5'],
            required: {
              depends: function (element) {
                return (
                  ($('[name="form_email_sub_1"]').length && $('[name="form_email_sub_1"]').val() !== '') ||
                  ($('[name="form_email_sub_2"]').length && $('[name="form_email_sub_2"]').val() !== '') ||
                  ($('[name="form_email_sub_3"]').length && $('[name="form_email_sub_3"]').val() !== '') ||
                  ($('[name="form_email_sub_4"]').length && $('[name="form_email_sub_4"]').val() !== '') ||
                  ($('[name="form_email_sub_5"]').length && $('[name="form_email_sub_5"]').val() !== '')
                );
              }
            }
          },
          'form_confirm': {
            equalTo: {
              param: '#js-email',
              depends: function (element) {
                return $('[name="form_confirm"]').val() !== '';
              }
            }
          },
          'form_email_sub_1': {
            email: true,
            differentall: ['form_email', 'form_email_sub_2', 'form_email_sub_3', 'form_email_sub_4', 'form_email_sub_5'],
          },
          'form_confirm_sub_1': {
            equalTo: {
              param: '#js-emailSub1',
              depends: function (element) {
                return $('[name="form_confirm_sub_1"]').val() !== '';
              }
            }
          },
          'form_email_sub_2': {
            email: true,
            differentall: ['form_email', 'form_email_sub_1', 'form_email_sub_3', 'form_email_sub_4', 'form_email_sub_5'],
          },
          'form_confirm_sub_2': {
            equalTo: {
              param: '#js-emailSub2',
              depends: function (element) {
                return $('[name="form_confirm_sub_2"]').val() !== '';
              }
            }
          },
          'form_email_sub_3': {
            email: true,
            differentall: ['form_email', 'form_email_sub_1', 'form_email_sub_2', 'form_email_sub_4', 'form_email_sub_5'],
          },
          'form_confirm_sub_3': {
            equalTo: {
              param: '#js-emailSub3',
              depends: function (element) {
                return $('[name="form_confirm_sub_3"]').val() !== '';
              }
            }
          },
          'form_email_sub_4': {
            email: true,
            differentall: ['form_email', 'form_email_sub_1', 'form_email_sub_2', 'form_email_sub_3', 'form_email_sub_5'],
          },
          'form_confirm_sub_4': {
            equalTo: {
              param: '#js-emailSub4',
              depends: function (element) {
                return $('[name="form_confirm_sub_4"]').val() !== '';
              }
            }
          },
          'form_email_sub_5': {
            email: true,
            differentall: ['form_email', 'form_email_sub_1', 'form_email_sub_2', 'form_email_sub_3', 'form_email_sub_4'],
          },
          'form_confirm_sub_5': {
            equalTo: {
              param: '#js-emailSub5',
              depends: function (element) {
                return $('[name="form_confirm_sub_5"]').val() !== '';
              }
            }
          },
          'form_user_pass': {
            minlength: 6,
            password: true,
            notnumberonly: true,
          },
          'form_user_pass_confirm': {
            equalTo: '#js-password',
          },

          'form_basic_code': {
            minlength: 8,
            number: true,
            required: {
              depends: function (element) {
                return $('#js-validateBasicCode').val() === '1';
              }
            }
          },
          'form_basic_name': {
            required: {
              depends: function (element) {
                return $('#js-validateBasicName').val() === '1';
              }
            }
          },
          'form_basic_name_kana': {
            kana: true,
            required: {
              depends: function (element) {
                return $('#js-validateBasicNameKana').val() === '1';
              }
            }
          },
          'form_basic_company': {
            required: {
              depends: function (element) {
                return $('#js-validateBasicCompany').val() === '1';
              }
            }
          },
          'form_basic_company_kana': {
            kana: true,
            required: {
              depends: function (element) {
                return $('#js-validateBasicCompanyKana').val() === '1';
              }
            }
          },
          'form_basic_department': {
            required: {
              depends: function (element) {
                return $('#js-validateBasicDepartment').val() === '1';
              }
            }
          },
          'form_basic_position': {
            required: {
              depends: function (element) {
                return $('#js-validateBasicPosition').val() === '1';
              }
            }
          },
          'form_basic_zipcode': {
            zipcode: true,
            required: {
              depends: function (element) {
                return $('#js-validateBasicZipcode').val() === '1';
              }
            }
          },
          'form_basic_prefectures': {
            required: {
              depends: function (element) {
                return $('#js-validateBasicPrefectures').val() === '1';
              }
            }
          },
          'form_basic_address': {
            required: {
              depends: function (element) {
                return $('#js-validateBasicAddress').val() === '1';
              }
            }
          },
          'form_basic_tel': {
            phone: true,
            required: {
              depends: function (element) {
                return $('#js-validateBasicTel').val() === '1';
              }
            }
          },
          'form_basic_fax': {
            phone: true,
            required: {
              depends: function (element) {
                return $('#js-validateBasicFax').val() === '1';
              }
            }
          },
          'form_basic_email': {
            email: true,
            required: {
              depends: function (element) {
                return $('#js-validateBasicEmail').val() === '1';
              }
            }
          },
          'form_basic_note': {
            required: {
              depends: function (element) {
                return $('#js-validateBasicNote').val() === '1';
              }
            }
          },

          'form_custom_1': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom1').val() === '1';
              }
            }
          },
          'form_custom_1[]': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom1').val() === '1';
              }
            }
          },
          'form_custom_2': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom2').val() === '1';
              }
            }
          },
          'form_custom_2[]': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom2').val() === '1';
              }
            }
          },
          'form_custom_3': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom3').val() === '1';
              }
            }
          },
          'form_custom_3[]': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom3').val() === '1';
              }
            }
          },
          'form_custom_4': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom4').val() === '1';
              }
            }
          },
          'form_custom_4[]': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom4').val() === '1';
              }
            }
          },
          'form_custom_5': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom5').val() === '1';
              }
            }
          },
          'form_custom_5[]': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom5').val() === '1';
              }
            }
          },
          'form_custom_6': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom6').val() === '1';
              }
            }
          },
          'form_custom_6[]': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom6').val() === '1';
              }
            }
          },
          'form_custom_7': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom7').val() === '1';
              }
            }
          },
          'form_custom_7[]': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom7').val() === '1';
              }
            }
          },
          'form_custom_8': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom8').val() === '1';
              }
            }
          },
          'form_custom_8[]': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom8').val() === '1';
              }
            }
          },
          'form_custom_9': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom9').val() === '1';
              }
            }
          },
          'form_custom_9[]': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom9').val() === '1';
              }
            }
          },
          'form_custom_10': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom10').val() === '1';
              }
            }
          },
          'form_custom_10[]': {
            required: {
              depends: function (element) {
                return $('#js-validateCustom10').val() === '1';
              }
            }
          },

        };
      }


      formTag.validate({
        ignore: [],
        focusInvalid: false,
        rules: $rules,
        errorLabelContainer: "#messageBox",
        errorPlacement: function (error, element) {
          name = element.attr("name");
          if (
            name !== 'xxx'
          ) {
            var str = name.replace(/\[\d*\]/g, '');
            error.prependTo($("#" + str + "_error"));
          } else {
            error.insertAfter(element);
          }
        },
        submitHandler: function (form) {
          formTag.children('input[name="javascript_action"]').val('on');
          form.submit();
        },
        invalidHandler: function (form, validator) {

          if (!validator.numberOfInvalids()) { return; }

          $('html, body').animate({
            scrollTop: $(validator.errorList[0].element).offset().top - 100
          }, 400);

        }
      });

    });

  }


})(jQuery);